// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__OcnEb","header":"style_header__MZ8wE","footer":"style_footer__y2WW7"};